export const AppPermissions = {
   STANDARD: 'standard',
   BACKOFFICE: 'backoffice',
} as const;

export type ProfileRoles = (typeof AppPermissions)[keyof typeof AppPermissions];
export type PermissionsOperation = 'and' | 'or';
